// extracted by mini-css-extract-plugin
export default {"container":"Encontrados_container__fd4FR","titulo":"Encontrados_titulo__lmJ84"};